import { moduleProviderFactory } from 'core/providers';
import { RateCalculator } from 'modules/rate-calculator/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.rate-calculator',
				pattern: '/rate-calculator',
				isPrivate: true,
				authorization: ['rateCalculatorSection.full'],
				children: [
					{
						name: 'master.app.main.rate-calculator',
						pattern: '',
						component: RateCalculator,
					},
				],
			},
		],
	});
})();
